import { IUserNotification } from '@tableau/user-notifications-client-core';
import _ from 'underscore';

import { ServerApiMapper } from '~commonInfra/utils/ServerModelHelper';

import { IListWithTokenFetcher } from '../../httpClient/fetchers/IListWithTokenFetcher';
import { ListResultWithToken } from '../../httpClient/fetchers/ListResultWithToken';
import { WebClientListWithTokenResourceFetcher } from '../../httpClient/fetchers/resourceFetchers/WebClientListWithTokenResourceFetcher';
import { ResourceQueryWithPagingToken } from '../../httpClient/resources/ResourceQueryWithPagingToken';
import { IRequest } from '../../httpClient/serverApi/types/IRequest';
import WebHttpClient from '../../httpClient/WebHttpClient';
import { CheckHasUnseenUserNotificationsRequest } from '../redux/serverRequests/CheckHasUnseenUserNotificationsRequest';
import { DeleteUserNotificationRequest } from '../redux/serverRequests/DeleteUserNotificationRequest';
import { GetUserNotificationsRequest } from '../redux/serverRequests/GetUserNotificationsRequest';
import { UpdateLastSeenUserNotificationRequest } from '../redux/serverRequests/UpdateLastSeenUserNotification';
import { UpdateUserNotificationReadStateRequest } from '../redux/serverRequests/UpdateUserNotificationReadStateRequest';


class UserNotificationsResource {
  PAGE_SIZE = 100;
  private listFetcher: IListWithTokenFetcher<IUserNotification<any>> = new WebClientListWithTokenResourceFetcher(GetUserNotificationsRequest, ServerApiMapper.userNotifications);

  public all(): ResourceQueryWithPagingToken<IUserNotification<any>> {
    return new ResourceQueryWithPagingToken(this.listFetcher);
  }

  public getUserNotificationsPage(nextPageToken: string) {
    return this.all().getPage(nextPageToken, this.PAGE_SIZE).then(
      (listResult: ListResultWithToken<IUserNotification<any>>) => {
        const notificationDict = _.indexBy(listResult.items, 'id');
        const nextPageToken = listResult.nextPageToken;
        const getUserNotificationsResult = {
          notificationDict: notificationDict,
          nextPageToken: nextPageToken
        };
        return getUserNotificationsResult;
      });
  }

  public updateNotificationsStatus(ids: string[], isRead: boolean): Promise<{}> {
    const params = { ids: ids, readState: isRead };
    return this.sendRequest(new UpdateUserNotificationReadStateRequest(params));
  }

  public deleteNotification(id: string): Promise<{}> {
    return this.sendRequest(
      new DeleteUserNotificationRequest({ id: id }));
  }

  public checkHasUnseenUserNotifications(): Promise<boolean> {
    return this.sendRequest(
      new CheckHasUnseenUserNotificationsRequest()).then(result => result.hasUnseenNotifications);
  }

  public updateLastSeenUserNotification(id: string): Promise<{}> {
    return this.sendRequest(
      new UpdateLastSeenUserNotificationRequest(id));
  }

  private sendRequest<TParams, TResult>(request: IRequest<TParams, TResult>): Promise<TResult> {
      return WebHttpClient.sendRequest(request);
  }
}

export const UserNotificationsResources = new UserNotificationsResource();
